import queryString from "query-string";

import { MASTER_RULE_SET, RULE_SET } from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import {
  offlineActionCreator,
  passthroughSerializer,
  urlCheckAndAddIdAndAction,
} from "./lib";

const ruleSetUrlCreator = ({
  changesSince,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/rule-sets/", id, action),
    query: {
      changesSince,
    },
  });

export const RuleSetAction = offlineActionCreator(
  RULE_SET,
  passthroughSerializer,
  ruleSetUrlCreator,
  false,
);

RuleSetAction.addRuleToNewRuleSet = (ruleSetValues, ruleId) => ({
  type: RULE_SET.ADD_RULE_TO_NEW_RULE_SET.ACTION,
  ruleSetValues,
  ruleId,
});

RuleSetAction.addRulesToExistingRuleSet = (ruleIds, ruleSetId) => ({
  type: RULE_SET.ADD_RULES_TO_EXISTING_RULE_SET.ACTION,
  ruleIds,
  ruleSetId,
});

const masterRuleSetUrlCreator = ({
  changesSince,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/master-rule-sets/", id, action),
    query: {
      changesSince,
    },
  });

export const MasterRuleSetAction = offlineActionCreator(
  MASTER_RULE_SET,
  passthroughSerializer,
  masterRuleSetUrlCreator,
  false,
);
